//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DefaultEvents from "@/components/objects/public/shared-blocks/links/events/design-variant/Default.vue";
import LineEvents from "@/components/objects/public/shared-blocks/links/events/design-variant/Line.vue";
import { LIST_COLORS } from "@/constants/ui.js";
import { getDefaultEventsSettingsForDesign, getDefaultThemeSettings } from "@/constants/ui.js";
import { DesignExtra } from "@/utils/dto/objects.js";
import isEmpty from "lodash/isEmpty.js";

export default {
  name: "LinksEvents",
  components: {
    DefaultEvents,
    LineEvents,
  },
  provide: {
    source: 'objTimeline',
    module: 'links_events'
  },
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    list: {
      type: Object,
      default: () => ({})
    },
    object_id: {
      type: String,
      default: ""
    },
    objectLabel: {
      type: String,
      default: ""
    },
    useStorage: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    },
    designExtra: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    const safeList = this.list || {};
    const design = safeList.design || 'links_events_default';
    const ui = safeList.ui_data || {};
    const defaultTheme = getDefaultThemeSettings(design, 'links_events', this.$store)?.themes?.[0];
    const listExtra = safeList.design_extra;
    const propExtra = this.designExtra;
    const resolvedExtra = !isEmpty(listExtra)
      ? listExtra
      : (!isEmpty(propExtra) ? propExtra : new DesignExtra(defaultTheme || getDefaultEventsSettingsForDesign(design)));
    return {
      detail: false,
      currentDesign: design,
      currentTheme: ui.design_theme || defaultTheme?.theme || design,
      designExtraLocal: resolvedExtra,
      colors: [...LIST_COLORS],
      pageSize: 12,
      total: 0,
      items: [],
      templateValue: null,
      isInitialized: false,
    }
  },
  computed: {
    designExtraResolved() {
      return this.designExtraLocal
    },
    renderComponent() {
      return this.currentDesign === 'links_events_line' ? LineEvents : DefaultEvents
    },
    prepopulatedItems() {
      if (this.items.length < this.total) {
        return [...this.items, { id: "load-next", loader: true }]
      }
      return this.items
    },
    listInfo() {
      return {
        label: this.list.label,
        subLabel: this.list.sublabel || "",
        icon: this.list.icon,
        vistat_object: this.list.vistat_object,
        object_label: this.objectLabel,
        id: this.list.id,
      }
    },
  },
  created() {
    this.total = this.list.total
    this.items = [...this.list.items]
  },
  mounted(){
    this.updatePageSize()

    window.addEventListener('resize', this.updatePageSize, { passive: true })
  },
  destroyed() {
    window.removeEventListener('resize', this.updatePageSize)
  },
  methods: {
    updatePageSize() {
      if (typeof window !== "undefined") {
        if (window.innerWidth <= 640 ) {
          this.pageSize = 6
          if (!this.isInitialized) {
            this.items = this.items.slice(0, 6)
          }
        } else {
          this.pageSize = 12
          if (this.items.length < 12) {
            this.loadNextItems(6)
          }
        }
        this.isInitialized = true
      }
    },
    loadNextItems(count) {
      if (this.inProgress) return
      if (this.items.length >= this.total) return;
      this.inProgress = true

      if (this.list.id) {
        this.$axios.$get(`/public/objects/${this.object_id}/links/${this.list.id}/`, {
          params: {
            limit: count || this.pageSize,
            offset: this.items.length,
          }
        })
          .then(({ items }) => {
            this.items.push(...items)
          })
          .finally(() => this.inProgress = false)
      } else {
        this.items.push(...this.list.full_items_list.slice(this.items.length));
      }
    },
    onTemplateChange(evt) {
      this.templateValue = evt;
    },
    onDesignChange(evt) {
      this.currentDesign = evt;
      const defaultTheme = getDefaultThemeSettings(evt, 'links_events', this.$store)?.themes?.[0];
      this.designExtraLocal = new DesignExtra(defaultTheme || getDefaultEventsSettingsForDesign(evt));
      this.currentTheme = defaultTheme?.theme || evt;
    },
    onThemeChange(evt) {
      this.currentTheme = evt;
      const designSettings = getDefaultThemeSettings(this.currentDesign, 'links_events', this.$store);
      const themeObj = designSettings?.themes?.find(el => el.theme === evt);
      this.designExtraLocal = new DesignExtra(themeObj || getDefaultEventsSettingsForDesign(this.currentDesign));
    },
  }
}
